import { ContrachequeDetalhesValoresAposentadosModel } from './contracheque-detalhes-valores-aposentados.model';
import { ContrachequeDetalhesValoresModel } from './contracheque-detalhes-valores-func.model';

export class ContraChequeFuncCentrusModel {

  constructor(
    public cdCentrusResp?: string,
    public cdFuncao?: string,
    public cdNivelComis?: string,
    public cdRegional?: string,
    public cdVp?: string,
    public dsMensagemGeral?: string,
    public dsMensagemInd?: string,
    public irIsencaoIr?: string,
    public irRemessaEspelho?: string,
    public noBenefr?: string,
    public noResp?: string,
    public nrAgencia?: string,
    public nrAgenciaResp?: string,
    public nrBanco?: string,
    public nrBancoResp?: string,
    public nrBenefInss?: string,
    public nrContaCorrente?: string,
    public nrContaCorrenteResp?: string,
    public nrNivel?: string,
    public qtAnuenio?: string,
    public qtDepIr?: string,
    public qtDepSalFam?: string,
    public sgCarreira?: string,
    public vlBruto?: string,
    public vlDescontos?: string,
    public vlFgts?: string,
    public vlLiquido?: string,
    public vlMargem30?: string,
    public vlMargem70?: string,
    public vlSalarioBase?: string,
    public noPessoa?: string,
    public sgLocal?: string,
    public contrachequeDetalhesValoresFuncDTO?: Array<ContrachequeDetalhesValoresModel>
    ) {
     this.contrachequeDetalhesValoresFuncDTO = new  Array<ContrachequeDetalhesValoresModel>();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/contra-cheque-func-centrus.model.ts